import { useFormValidation } from '@pattern-library/base';
import {
    combine,
    focusFirstInvalidInput,
    updateAriaLiveMessage
} from '../utilities/validation-behavior';

/**
 * Like the {@link useFormValidation} hook, but with some common behaviors by default.
 * This hook is optimized for short forms with a few fields -- that's most forms in
 * Unified Login, but if you have a different use case, consider customizing this
 * hook's behavior with the `onValidate` parameter, or creating your own implementation
 * with `useFormValidation`.
 *
 * @param {import("@pattern-library/base/dist/js/hooks/useFormValidation").FormValidationConfig} config
 * @returns {import("@pattern-library/base/dist/js/hooks/useFormValidation").FormValidationBag}
 */
const useUnifiedLoginFormValidation = ({ schema, onValidate: customOnValidate }) => {
    const handlers = [
        focusFirstInvalidInput,
        updateAriaLiveMessage({ target: 'ul-form-validation-summary' }),
        customOnValidate
    ].filter(handler => typeof handler !== 'undefined');

    return useFormValidation({
        schema,
        onValidate: combine(...handlers)
    });
};

export default useUnifiedLoginFormValidation;
